import * as S from './style';

export default function Shadow({transform}) {
    return (
        <S.Wrapper $transform={transform}></S.Wrapper>
    )
}